export default "__VITE_ASSET__ATTaDNFo__"